export class DecryptionError extends Error {
    suggestion: string;

    constructor(message = "", suggestion: string) {
        super(message);

        // Fix transpiling to ES5
        Object.setPrototypeOf(this, new.target.prototype);

        this.message = message;
        this.suggestion = suggestion;
    }
}

export class VerificationError extends Error {
    constructor(message = "Failed to verify signed data.") {
        super(message);

        // Fix transpiling to ES5
        Object.setPrototypeOf(this, new.target.prototype);

        this.message = message;
    }
}
